import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import {
  contractDayReservableAreasDataSchema,
  type contractDayReservableAreasData,
} from '../../../common/validations/contractDayReservableAreasSchema'

import { get } from 'api/apiClient'

export type IncludeFilter = 'all' | 'own'

export const contractDayReservableAreasKey = (
  contractUuid: string,
  include: IncludeFilter = 'all'
) => ['contracts', contractUuid, 'day-reservable-areas', include] as const

const path = (contractUuid: string, include: IncludeFilter) =>
  `${API_ENDPOINTS.CONTRACT_DAY_RESERVABLE_AREAS.replace(':contractUuid', contractUuid)}?include=${include}`

const params = (contractUuid: string, include: IncludeFilter = 'all') => ({
  queryKey: contractDayReservableAreasKey(contractUuid, include),
  queryFn: () =>
    get<contractDayReservableAreasData>(
      path(contractUuid, include),
      contractDayReservableAreasDataSchema
    ),
  staleTime: 0 as const,
})

export const useAPIGetContractDayReservableAreas = (
  contractUuid: string | undefined,
  include: IncludeFilter = 'all'
) =>
  useQuery<contractDayReservableAreasData>({
    ...(params(contractUuid ?? '', include) as ReturnType<typeof params>),
    enabled: Boolean(contractUuid),
  })

export const useAPIGetContractDayReservableAreasSuspense = (
  contractUuid: string,
  include: IncludeFilter = 'all'
) =>
  useSuspenseQuery<contractDayReservableAreasData>(
    params(contractUuid, include) as ReturnType<typeof params>
  )
